import Icon from '../components/Icon.vue'

Icon.register({"square-full":{"width":512,"height":512,"paths":[{"d":"M512 512H0V0H512V512z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/square-full.js
// module id = HnrZ
// module chunks = 0